/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import { greenApiWebhookInteractiveButtonsResponseRequestSchema } from "./greenApiWebhookInteractiveButtonsResponseRequestSchema.ts";
import { greenApiWebhookTextMessageDataRequestSchema } from "./greenApiWebhookTextMessageDataRequestSchema.ts";
import { typeMessageEnumSchema } from "./typeMessageEnumSchema.ts";

export const greenApiWebhookMessageDataRequestSchema = z.object({
	typeMessage: typeMessageEnumSchema.describe("* `interactiveButtonsResponse` - Interactive Buttons Response\n* `textMessage` - Text Message"),
	interactiveButtonsResponse: greenApiWebhookInteractiveButtonsResponseRequestSchema.nullish(),
	textMessageData: greenApiWebhookTextMessageDataRequestSchema.nullish(),
});
